export const propertyType = str => {
  if (str && isNaN(str) && (str.toUpperCase() === 'APARTAMENTO' || str.toUpperCase() === 'CASA')) {
    return str.toUpperCase();
  }
};
